export default "__VITE_ASSET__D5vp6Wev__"